import type { FormValues } from "@/widgets/classic-form/form";
import { FieldComposer, fieldToConfig } from "@/features/form-fields";
import { type Field, NameAssertion, type NameAssertion as NameAssertionType } from "@/entities/form-metadata";
import type { FieldPath, PrefixObjectAccessor } from "@/shared/forms";

interface FamilyMemberNameInputBaseProps {
    metadata: Field<NameAssertionType>;
    basePath: FieldPath<FormValues>;
    inputProperties?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const NameInput = ({ metadata, basePath, inputProperties }: FamilyMemberNameInputBaseProps) => (
    <FieldComposer
        fieldPath={basePath}
        fieldConfig={fieldToConfig(metadata)}
        {...(metadata.assertion !== NameAssertion.SecondSurname
            ? { exactnessFieldPath: `${basePath}Exactness.isExact` as PrefixObjectAccessor<FormValues, []> }
            : {})}
    >
        <FieldComposer.FieldConnector>
            {({ formField, fieldConfig, fieldPath }, fieldHtmlId) => (
                <FieldComposer.Inputs.String
                    {...inputProperties}
                    id={fieldHtmlId}
                    data-testid={fieldPath}
                    required={fieldConfig.required}
                    minLength={fieldConfig.minLength}
                    {...formField}
                />
            )}
        </FieldComposer.FieldConnector>
        {metadata.assertion !== NameAssertion.SecondSurname && <FieldComposer.GenericExactness />}
    </FieldComposer>
);
